<template>
  <section class="container">
    <div class="title-container">
      <h1>{{ item.item }}</h1>
      <p class="sub-title">対象：{{ item.belong }}さま</p>
    </div>
    <div class="requirement-container">
      <span class="requirement-batch">条件</span>
      <span class="requirement-content">{{ item.requirement }}</span>
    </div>
    <a class="ex-link" :href="item.url_path">{{ item.url_path }}</a>
    <p class="example">{{ item.example }}</p>
  </section>
</template>

<script>
export default {
	props:{
		item:Object
	}
}
</script>

<style scoped>
.container {
  text-align: left;
}

.title-container {
  display: flex;
  padding-left: 0.2em;
  flex-wrap: wrap;
  align-items: flex-end;
}

.title {
}

.sub-title {
  margin-top: 1em;
  margin-left: 1em;
  text-decoration: underline;
}

.requirement-container {
  margin: 0.2em 0;
}

.requirement-batch {
  padding: 0 0.5em;
  color: var(--bg-color);
  background-color: var(--main-color);
  border-radius: 1em;
}

.requirement-content {
  margin-left: 0.4em;
  padding-right: 0.4em;
}

.ex-link {
  color: #76cde3;
  padding-left: 0.4em;
  padding-right: 0.4em;
  text-decoration: underline;
  overflow-wrap: break-word;
}

.example {
  padding: 0.6em 0.4em 0 0.4em;
  font-size: 1.1em;
}
</style>